/* Bidirectional sticky for the silco-pdp product-info column.
 *
 * When the info column is TALLER than the viewport:
 *  - scrolling DOWN: the column scrolls with the page until its bottom edge
 *    reaches the viewport bottom, then pins there while the gallery keeps
 *    scrolling; after the gallery ends the page continues normally.
 *  - scrolling UP: the column immediately scrolls down with the page (top
 *    content re-appears) until its top reaches the header line, then pins.
 * When it FITS the viewport it's a plain top-sticky column.
 *
 * Works by driving two CSS vars on the sticky element: --sp-top (sticky top)
 * and --sp-m (margin-top that re-anchors the flow position on direction
 * changes so there is never a visual jump).
 */
(function () {
  var MQ = window.matchMedia('(min-width: 990px)');

  function headerOffset(el) {
    var v = getComputedStyle(document.documentElement).getPropertyValue('--header-height');
    var h = parseFloat(v);
    if (isNaN(h)) {
      var hg = document.querySelector('.shopify-section-group-header-group');
      h = hg ? hg.offsetHeight : 0;
    }
    return h + (parseFloat(el.dataset.spOffset || '0') || 0);
  }

  function init(el) {
    var col = el.parentElement;
    if (!col) return;
    var lastY = window.scrollY;
    var mode = 'up';

    function set(top, m) {
      el.style.setProperty('--sp-top', top + 'px');
      el.style.setProperty('--sp-m', m + 'px');
    }

    function update() {
      if (!MQ.matches) {
        el.style.removeProperty('--sp-top');
        el.style.removeProperty('--sp-m');
        return;
      }
      var y = window.scrollY;
      var down = y > lastY;
      var moved = y !== lastY;
      lastY = y;

      var topOff = headerOffset(el);
      var winH = window.innerHeight;
      var elH = el.offsetHeight;

      // Fits on screen → plain top-sticky.
      if (elH + topOff <= winH) {
        set(topOff, 0);
        return;
      }

      var minTop = winH - elH; // top position when bottom-pinned (negative)
      var rect = el.getBoundingClientRect();
      var contTop = col.getBoundingClientRect().top;
      var newMode = moved ? (down ? 'down' : 'up') : mode;

      if (newMode !== mode) {
        mode = newMode;
        // Direction changed: re-anchor the flow position at the current visual
        // spot and release the pin, so the column free-scrolls with the page.
        set(minTop, rect.top - contTop);
        return;
      }

      if (mode === 'up' && rect.top >= topOff - 0.5) {
        // Free-scrolled back far enough — pin at the header line.
        set(topOff, 0);
      }
      // mode === 'down': sticky pins at minTop by itself, nothing to do.
    }

    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    if (window.ResizeObserver) {
      var ro = new ResizeObserver(update);
      ro.observe(el);
      ro.observe(col);
    }
    update();
  }

  function boot() {
    document.querySelectorAll('[data-sp-sticky]').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
